import React from 'react';

import { SubHeading } from '../../components'
import { images } from '../../constants';
import './Header.css';

const Header = () => (
  <div className='app__header app__wrapper section__padding' id='home'>
    <div className='app__wrapper_info'>
      <SubHeading title='Chase the new flavour' />
      <h1 className='app__header-h1'>The Key to Fine Dining</h1>
      <p style={{ margin: '2rem 0' }}>Experience the epitome of elegance and refinement at our fine dining restaurant. Savor the flavors of the season with our ever-changing menu, featuring the freshest, locally-sourced ingredients. Our expert chefs take great care in presenting each dish as a work of art, with an emphasis on color, texture, and balance. We pride ourselves on attention to detail, making sure every aspect of your dining experience is perfect. Join us for an unforgettable culinary journey and indulge in the finest dining experience.</p>
      <a href='#menu'>
        <button type='button' className='custom__button'>Explore Menu</button>
      </a>
    </div>
    <div className='app__wrapper_img'>
      <img src={images.welcome} alt="header img" />
    </div>
  </div>
);

export default Header;
